import React, { Component } from "react";
import {
  profile,
  toFixed,
  format_date,
  GET,
  loading,
  DateRangePicker,
  Navbar,
  copyText,
} from "../../components/CustomComponent.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

import Countup from "react-countup";
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_customer: [],
      data_deposits: [],
      data_withdrawals: [],

      count_customer: 0,

      filter_start_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        "yyyy-MM-dd",
        "en",
      ),
      filter_end_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        "yyyy-MM-dd",
        "en",
      ),
      filter_currency: "THB",
      array_date: [],
    };
  }

  async componentDidMount() {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
    );
    loading(false);
    await this.Get(0);
  }
  Get = async () => {
    const { filter_start_date, filter_end_date, filter_currency } = this.state;
    loading(true);
    let data_customer,
      count_customer,
      deposit,
      withdrawal,
      refund,
      chart_deposit,
      chart_withdrawal;
    let _date_start = format_date(filter_start_date, "yyyy-MM-dd", "en");
    let _date_end = format_date(filter_end_date, "yyyy-MM-dd", "en");
    let _array_date = [];
    let current = new Date(_date_start);

    while (current <= new Date(_date_end)) {
      _array_date.push(format_date(current, "dd/MM"));
      current.setDate(current.getDate() + 1); // เพิ่มทีละวัน
    }

    let [result_customer, result_gmv, result_chart] = await Promise.all([
      GET("v1/admin/customers", {
        page_size: 10,
        page: 1,
        data_search: "",
        currency: filter_currency,
      }),
      GET("v1/admin/dashboards/gmv", {
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        currency: filter_currency,
      }),
      GET("v1/admin/dashboards/chart-gmv", {
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        currency: filter_currency,
      }),
    ]);

    if (result_customer?.status) {
      data_customer = result_customer.data;
      count_customer = result_customer?.pagination?.count || 0;
    }
    if (result_gmv?.status) {
      deposit = result_gmv.data.deposit;
      withdrawal = result_gmv.data.withdrawals;
      refund = result_gmv.data.refund;
    }
    if (result_chart?.status) {
      chart_deposit = result_chart.data.deposit;
      chart_withdrawal = result_chart.data.withdrawals;
    }
    this.setState({
      data_customer,
      count_customer,

      deposit,
      withdrawal,
      refund,

      chart_deposit,
      chart_withdrawal,

      array_date: _array_date,
    });
    loading(false);
  };
  render() {
    const {
      filter_start_date,
      filter_end_date,
      filter_currency,
      data_customer,
      count_customer,

      deposit,
      withdrawal,
      refund,

      chart_deposit,
      chart_withdrawal,

      array_date,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* Header: หัว hero + Filter (ช่วงวันที่ / สกุลเงิน) */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Overview</div>
                <div className="ar-title">Dashboard</div>
                <div className="ar-subtitle">
                  Welcome back, {profile?.full_name}! Here's your{" "}
                  {profile?.user_type.replaceAll("_", " ")} overview.
                </div>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{"\uf0b0"}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Period</span>
                  <div className="wpx-230">
                    <DateRangePicker
                      className="form-control"
                      onChange={(e) => {
                        this.setState(
                          {
                            filter_start_date: e.start_date,
                            filter_end_date: e.end_date,
                          },
                          () => {
                            if (
                              this.state.filter_start_date &&
                              this.state.filter_end_date
                            ) {
                              this.Get(0);
                            }
                          },
                        );
                      }}
                      value={{
                        start_date: filter_start_date,
                        end_date: filter_end_date,
                      }}
                      max={filter_end_date}
                    />
                  </div>
                </div>
              </div>
              <div className="ar-filter-foot">
                {global.currency?.map((item) => (
                  <button
                    type="button"
                    key={item.currency_code}
                    className={`ar-pill ${item.currency_code === filter_currency ? "active" : ""}`}
                    onClick={() => {
                      this.setState({ filter_currency: item.currency_code });
                      setTimeout(() => {
                        this.Get(1);
                      }, 100);
                    }}
                  >
                    {item.image}
                    <span className="ms-1">{item.currency_name}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                <div className="w-100">
                  <small className="text-secondary text-nowrap">
                    Customers
                  </small>
                  <h5 className="fw-bold mb-0">
                    <Countup
                      start={0}
                      end={Number(count_customer)}
                      duration={2}
                      separator=","
                    />
                  </h5>
                  <div
                    style={{ marginTop: -2, height: 15 }}
                    className="text-12 text-light"
                  >
                    .
                  </div>
                </div>
                <span className="icon text-purple">{"\uf007"}</span>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                <div className="w-100">
                  <small className="text-secondary text-nowrap">
                    Total Refund Amount
                  </small>
                  <h5 className="fw-bold mb-0">
                    <Countup
                      start={0}
                      end={Number(refund?.amount)}
                      duration={2}
                      separator=","
                    />{" "}
                    <span className="text-16">{filter_currency}</span>
                  </h5>
                  <div
                    style={{ marginTop: -2, height: 15 }}
                    className="text-12 text-light"
                  >
                    .
                  </div>
                </div>
                <span className="icon text-info">{"\uf0d6"}</span>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="row">
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Deposits Amount
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.amount)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-primary"
                      >
                        <Countup
                          start={0}
                          end={Number(deposit?.count || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        Orders
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf0d6"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Deposits Fee
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.fee)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf53b"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Deposits Net
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.amount_net || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf53d"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Deposits (AOV)
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.average)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf53d"}</span>
                  </div>
                </div>
              </div>
              <div className="ar-table-card">
                <div className="ar-table-head flex-wrap gap-2">
                  <div>
                    <div className="ar-table-title">
                      <span className="icon me-2 pu-title-icon">
                        {"\uf201"}
                      </span>
                      Monthly Deposits
                    </div>
                    <div className="ar-table-caption">
                      Deposit trends between {format_date(filter_start_date)} -{" "}
                      {format_date(filter_end_date)}
                    </div>
                  </div>
                </div>
                <div className="ar-chart" style={{ height: 340 }}>
                  <Line
                    datasetIdKey="id"
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                    }}
                    data={{
                      labels: array_date,
                      datasets: [
                        {
                          id: 1,
                          label: "Amount",
                          data:
                            chart_deposit?.chart_amount?.map((e) => e.value) ||
                            [],
                          backgroundColor: "rgba(75, 192, 192, 0.2)",
                          borderColor: "rgba(75, 192, 192, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 2,
                          label: "Fee",
                          data:
                            chart_deposit?.chart_fee?.map((e) => e.value) || [],
                          backgroundColor: "rgba(255, 99, 132, 0.2)",
                          borderColor: "rgba(255, 99, 132, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 3,
                          label: "VAT",
                          data:
                            chart_deposit?.chart_vat?.map((e) => e.value) || [],
                          backgroundColor: "rgba(255, 206, 86, 0.2)",
                          borderColor: "rgba(255, 206, 86, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 4,
                          label: "Amount Net",
                          data:
                            chart_deposit?.chart_amount_net?.map(
                              (e) => e.value,
                            ) || [],
                          backgroundColor: "rgba(153, 102, 255, 0.2)",
                          borderColor: "rgba(153, 102, 255, 1)",
                          borderWidth: 2,
                        },
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="row">
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Withdrawals Amount
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.amount || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-primary"
                      >
                        <Countup
                          start={0}
                          end={Number(withdrawal?.count || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        Orders
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf0d6"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Withdrawals Fee
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.fee || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf53b"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Withdrawals Net
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.amount_net)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf53d"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Withdrawals (AOV)
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.average)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf53d"}</span>
                  </div>
                </div>
              </div>
              <div className="ar-table-card">
                <div className="ar-table-head flex-wrap gap-2">
                  <div>
                    <div className="ar-table-title">
                      <span className="icon me-2 pu-title-icon">
                        {"\uf201"}
                      </span>
                      Monthly Withdrawals
                    </div>
                    <div className="ar-table-caption">
                      Withdrawal trends between {format_date(filter_start_date)}{" "}
                      - {format_date(filter_end_date)}
                    </div>
                  </div>
                </div>
                <div className="ar-chart" style={{ height: 340 }}>
                  <Line
                    datasetIdKey="id"
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                    }}
                    data={{
                      labels: array_date,
                      datasets: [
                        {
                          id: 1,
                          label: "Amount",
                          data:
                            chart_withdrawal?.chart_amount?.map(
                              (e) => e.value,
                            ) || [],
                          backgroundColor: "rgba(75, 192, 192, 0.2)",
                          borderColor: "rgba(75, 192, 192, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 2,
                          label: "Fee",
                          data:
                            chart_withdrawal?.chart_fee?.map((e) => e.value) ||
                            [],
                          backgroundColor: "rgba(255, 99, 132, 0.2)",
                          borderColor: "rgba(255, 99, 132, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 3,
                          label: "VAT",
                          data:
                            chart_withdrawal?.chart_vat?.map((e) => e.value) ||
                            [],
                          backgroundColor: "rgba(255, 206, 86, 0.2)",
                          borderColor: "rgba(255, 206, 86, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 4,
                          label: "Amount Net",
                          data:
                            chart_withdrawal?.chart_amount_net?.map(
                              (e) => e.value,
                            ) || [],
                          backgroundColor: "rgba(153, 102, 255, 0.2)",
                          borderColor: "rgba(153, 102, 255, 1)",
                          borderWidth: 2,
                        },
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 mb-3">
              <div className="ar-table-card h-100">
                <div className="ar-table-head flex-wrap gap-2">
                  <div>
                    <div className="ar-table-title">
                      <span className="icon me-2 pu-title-icon">
                        {"\uf0c0"}
                      </span>
                      Top 10 Customers
                    </div>
                    <div className="ar-table-caption">
                      Highest volume customers
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover ar-table pu-table pu-table-compact">
                    <thead>
                      <tr>
                        <td className="wpx-50 text-center">#</td>
                        <td className="text-nowrap">UID</td>
                        <td className="text-nowrap">Customer</td>
                        <td className="text-end text-nowrap">Deposits</td>
                        <td className="text-end text-nowrap">Withdrawals</td>
                      </tr>
                    </thead>
                    <tbody>
                      {data_customer?.map((item, index) => (
                        <tr key={`array-${index}`}>
                          <td data-label="#" className="text-center">
                            {index + 1}
                          </td>
                          <td data-label="UID" className="text-nowrap">
                            <div className="d-flex justify-content-between align-items-center">
                              {item.uid ? item.uid.slice(0, 12) + "..." : "-"}
                              <span
                                className="icon pointer ms-2"
                                title="Copy"
                                onClick={() => {
                                  copyText(item.uid || "");
                                }}
                              >
                                {"\uf0c5"}
                              </span>
                            </div>
                          </td>
                          <td data-label="Customer" className="text-nowrap">
                            {item.name_en || item.name_th || "-"}
                          </td>
                          <td
                            data-label="Deposits"
                            className="text-end text-nowrap py-1"
                          >
                            <div>
                              <div style={{ height: 14 }}>
                                <Countup
                                  start={0}
                                  end={Number(item.total_deposits || 0)}
                                  duration={2}
                                  separator=","
                                />
                              </div>
                              <small
                                className={
                                  item.order_deposits
                                    ? "text-primary"
                                    : "text-secondary"
                                }
                              >
                                <Countup
                                  start={0}
                                  end={Number(item.order_deposits)}
                                  duration={2}
                                  separator=","
                                />{" "}
                                orders
                              </small>
                            </div>
                          </td>
                          <td
                            data-label="Withdrawals"
                            className="text-end text-nowrap py-1"
                          >
                            <div>
                              <div style={{ height: 14 }}>
                                <Countup
                                  start={0}
                                  end={Number(item.total_withdrawals || 0)}
                                  duration={2}
                                  separator=","
                                />
                              </div>
                              <small
                                className={
                                  item.order_withdrawals
                                    ? "text-primary"
                                    : "text-secondary"
                                }
                              >
                                <Countup
                                  start={0}
                                  end={Number(item.order_withdrawals)}
                                  duration={2}
                                  separator=","
                                />{" "}
                                orders
                              </small>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
